"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createModalActions(_ref) {
  var type = _ref.type,
      target = _ref.target,
      contentTarget = _ref.contentTarget;
  return {
    open: function open(modalContent) {
      return {
        type: type + "_OPEN",
        target: target,
        payload: (0, _defineProperty3.default)({}, contentTarget, modalContent)
      };
    },
    close: function close() {
      var emptyModalContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return {
        type: type + "_CLOSE",
        target: target,
        payload: (0, _defineProperty3.default)({}, contentTarget, emptyModalContent)
      };
    }
  };
}

exports.default = createModalActions;